/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, April 2025
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage, epuapAttachmentsInfo } from '../utils/utils';
import { Popover, OverlayTrigger, Col, strong, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/lib/Button';
import { isMobileView, isTabletView } from '../utils/utils'


const fileBtnStyle = {
  cursor: 'pointer',
  marginLeft: '0px',
  padding: '4px 10px'
}

const standardFileNameStyle = {
  color: 'red',
  paddingLeft: '0px',
  paddingTop: '5px',
  verticalAlign: 'middle',
  display: 'inline-block',
  maxWidth: '500px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

const fileNameStyle = {
  color: 'red',
  verticalAlign: 'middle',
  display: 'inline-block',
  maxWidth: '150px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

const emptyErrorDict = {
  errorText: null,
  errorTitle: null,
  showError: false,
};

class PaymentConfirmationPanel extends React.Component {
  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    fileFormats: [],
    isMounted: false,
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    let fileFormats = ['docx', 'pdf', 'jpg', 'zip'];
    if (this.props.formats) {
      fileFormats = this.props.formats;
    }

    if (this.props.claim.transfer_payment_confirmation_file) {
      if (fileFormats.includes(this.props.claim.transfer_payment_confirmation_file.extension)) {
        const attachments = [...this.props.attachments];
        attachments[0] = {
          name: this.props.claim.transfer_payment_confirmation_file.name,
          extension: this.props.claim.transfer_payment_confirmation_file.extension,
          data: '',
        }
        this.setState(
          {
            colors,
            sourceStyle,
            style,
            fileFormats,
            isMounted: true
          }, () => this.props.onChangeAttachments(attachments, emptyErrorDict, true));
      }

    } else {
      this.setState({ colors, sourceStyle, style, fileFormats, isMounted: true });
    }
  }

  onAttachmentChange = async (e, idx) => {
    const file = e.target.files[0];
    const name = file.name;
    const extension = name.split('.').slice(-1)[0];
    const attachments = [...this.props.attachments];

    const formats = this.state.fileFormats.join(', ');
    const errorDict = {
      errorText: `Załącznik musi być w formacie ${formats}.`,
      errorTitle: 'Błędny format pliku.',
      showError: true,
    };
    if (this.state.fileFormats.includes(extension)) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = event => {
        const data = event.target.result;
        attachments[idx] = { name, extension, data };
        this.props.onChangeAttachments(attachments, emptyErrorDict, false)
      };
    } else { this.props.onChangeAttachments(attachments, errorDict); }
  }

  renderStandardRow = () => {
    return (
      this.props.attachments.map((attachment, i) =>
        <Row key={i}>
          <Col xs={2} style={{paddingBottom: '5px', paddingLeft: '15px' }}>
            <Button
              className="btn btn-default"
              style={fileBtnStyle}
              onClick={() => document.getElementById(`attachment_input_${i}`).click()}
            >
              Wybierz plik
            </Button>
          </Col>
          <Col xs={10} style={{ paddingBottom: '5px', paddingLeft: '0px' }}>
            <span style={standardFileNameStyle}>{attachment.name ? attachment.name : 'Nie wybrano pliku'}</span>
            <input id={`attachment_input_${i}`} type="file" style={{ color: 'red', width: '100%', display: 'none' }} accept=".pdf,.docx,.jpg,.zip" onChange={(e) => this.onAttachmentChange(e, i)} />
          </Col>
        </Row>,
      )
    )
  }

  renderStandardBankInfo = () => {
    return (
      <Row key={'bankInfoRow'} style={{ margin: '0' }}>
        <Col xs={3} style={{paddingBottom: '5px', paddingLeft: '15px' }}>
          <p><b>Numer rachunku:</b></p>
        </Col>
        <Col xs={5}>
        <p style={{ textAlign: 'right' }}><b>{this.props.bankAccountName ? this.props.bankAccountName : ''}</b></p>
        </Col>
        <Col xs={4}>
          <p style={{ textAlign: 'right' }}>{this.props.bankAccountNumber ? this.props.bankAccountNumber : ''}</p>
        </Col>
      </Row>
    )
  }

  renderMobileBankInfo = () => {
    return (
      <div style={{ marginBottom: '15px' }}>
        <Row key={'bankInfoMobileRow1'} style={{ margin: '0' }}>
          <Col xs={12} style={{paddingBottom: '5px', paddingLeft: '15px' }}>
            <p style={{ textAlign: 'center' }}><b>Numer rachunku:</b></p>
          </Col>
        </Row>
        <Row key={'bankInfoMobileRow2'} style={{ margin: '0' }}>
          <Col xs={12}>
          <p style={{ textAlign: 'center' }}><b>{this.props.bankAccountName ? this.props.bankAccountName : ''}</b></p>
          </Col>
          </Row>
        <Row key={'bankInfoMobileRow3'} style={{ margin: '0' }}>
          <Col xs={12}>
            <p style={{ textAlign: 'center' }}>{this.props.bankAccountNumber ? this.props.bankAccountNumber : ''}</p>
          </Col>
        </Row>
      </div>
    )
  }

  renderMobileRow = () => {
    return (
      this.props.attachments.map((attachment, i) =>
        <div key={i}>
          <Row>
            <Col xs={12} style={{ paddingBottom: '5px', paddingLeft: '5px', display: 'grid' }}>
              <Button
                className="btn btn-default"
                style={fileBtnStyle}
                onClick={() => document.getElementById(`attachment_input_${i}`).click()}
              >
                Wybierz plik
              </Button>
            </Col>
            </Row>
            <Row>
            <Col xs={12} style={{ padding: '5px', display: 'flex', justifyContent: 'center'}}>
              <span title={attachment.name ? attachment.name : 'Nie wybrano pliku'} style={fileNameStyle}>{attachment.name ? attachment.name : 'Nie wybrano pliku'}</span>
              <input id={`attachment_input_${i}`} type="file" style={{ color: 'red', width: '100%', display: 'none' }} accept=".pdf,.docx,.jpg,.zip" onChange={(e) => this.onAttachmentChange(e, i)} />
            </Col>
          </Row>
        </div>,
      )
    )
  }

  render() {
    const formats = this.state.fileFormats.join(', ');

    let isMobile = false;
    let isTablet = false;
    if (this.state.isMounted) {
      isMobile = isMobileView(window);
      isTablet = isTabletView(window);
    }
    return (
      <div style={{ fontSize: `${this.props.fontSize}rem`, clear: 'both' }}>
        <div className={'grayPanel'} style={this.state.style}>
          <div className="basePanelHeading" style={{ ...this.state.style, textAlign: isMobile || isTablet ? 'center': 'left' }}>Wykonaj przelew i dodaj potwierdzenie przelewu</div>
          <div className="panel-body" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
            {this.props.additionalText && <p><b>{this.props.additionalText}</b><br /></p>}
            {isMobile || isTablet ? this.renderMobileBankInfo() : this.renderStandardBankInfo()}
            <p style={{ paddingLeft: '15px', textAlign: isMobile || isTablet ? 'center': 'left' }}><b>Potwierdzenie przelewu:</b></p>
            <p style={{ paddingLeft: '15px' }}>Wymagane formaty załącznika: <b>{formats}</b>.</p>
            {this.props.attachments.length > 0 ?
              <div className="col-lg-12">
                {isMobile || isTablet? this.renderMobileRow() : this.renderStandardRow()}
              </div>
            : null }
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
});

export default connect(mapState)(PaymentConfirmationPanel);



// WEBPACK FOOTER //
// src/components/PaymentConfirmationPanel/PaymentConfirmationPanel.js